import { matchPath } from "react-router";

import { ADMIN_NAV_SECTIONS } from "@/routing/adminNavModel";
import type { AdminNavSectionId } from "@/routing/adminNavModel.types";
import {
  getAdminNavSectionIdForPathname,
  getAdminNavSidebarItems,
} from "@/routing/adminNavModelQueries";
import type {
  AdminRouteAccessArgs,
  SidebarNavigationItem,
} from "@/routing/adminRoutes";

export const getVNextActiveSectionId = (
  pathname: string,
): AdminNavSectionId | null => getAdminNavSectionIdForPathname(pathname);

/** The sidebar: sections, then pages (Nav PRD §10, F-195). */
export const getVNextSidebarNavigation = (
  _pathname: string,
  args: AdminRouteAccessArgs,
): SidebarNavigationItem[] => getAdminNavSidebarItems(args);

/** Administration and Developer sit below the one divider (F-196). */
export const isBelowNavDivider = (sectionId: string): boolean =>
  ADMIN_NAV_SECTIONS.some(
    (section) => section.id === sectionId && section.belowDivider === true,
  );

/**
 * A page row is current on its own address and on its tabs and records
 * (`activeMatchPaths` from the navigation map).
 */
export const isSidebarItemActive = (
  item: SidebarNavigationItem,
  pathname: string,
): boolean => {
  if (item.path && matchPath({ path: item.path, end: true }, pathname)) {
    return true;
  }

  return (
    item.activeMatchPaths?.some((pattern) =>
      Boolean(matchPath({ path: pattern, end: true }, pathname)),
    ) ?? false
  );
};

export const sidebarItemContainsActivePath = (
  item: SidebarNavigationItem,
  pathname: string,
): boolean =>
  isSidebarItemActive(item, pathname) ||
  (item.children?.some((child) =>
    sidebarItemContainsActivePath(child, pathname),
  ) ??
    false);
